import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import RootModal from '@/checkout-instore-legacy/components/Commons/RootModal'
import { actionCreators } from '../actions'
import { rootModalSelector } from '../selectors'

const mapStateToProps = (state) => {
  return { ...rootModalSelector(state) }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(actionCreators, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(RootModal)
